import { render } from "./CartModel.vue?vue&type=template&id=3b288e19&scoped=true"
import script from "./CartModel.vue?vue&type=script&lang=js"
export * from "./CartModel.vue?vue&type=script&lang=js"

import "./CartModel.vue?vue&type=style&index=0&id=3b288e19&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b288e19"]])

export default __exports__